import { selectIsChatBootstrapped } from 'ducks/chat/selectors/bootstrap'
import { createBasicSelector } from 'util/redux'
import { selectIsInChat } from 'selectors/location'
import { isBoostrappedSelector } from './base'

const selectIsCurrentAppBootstrapped = createBasicSelector(
  selectIsInChat,
  isBoostrappedSelector,
  selectIsChatBootstrapped,
  (isInChat, isInboxBootstrapped, isChatBootstrapped) => {
    if (isInChat) return isChatBootstrapped
    return isInboxBootstrapped
  }
)

export default selectIsCurrentAppBootstrapped
